import { render, staticRenderFns } from "./ZakazkaND.vue?vue&type=template&id=96978d9e&scoped=true&"
import script from "./ZakazkaND.vue?vue&type=script&lang=ts&"
export * from "./ZakazkaND.vue?vue&type=script&lang=ts&"
import style0 from "./ZakazkaND.vue?vue&type=style&index=0&id=96978d9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96978d9e",
  null
  
)

export default component.exports